export default {
      id: "chart-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#chart",
      toString: function () {
        return this.url;
      }
    }